import React from "react";
import { FaPalette } from "react-icons/fa";
import SettingsSectionShell, {
  SettingsSubgroupHeader,
} from "./SettingsSectionShell";
import SettingsFieldCard from "./SettingsFieldCard";
import TimeDateSection from "./TimeDateSection";
import valuesEqual from "./hooks/valuesEqual";

const COLOR = "indigo";

/**
 * "Görüntü ve Saat" bölümü — Görüntü Ayarları (profile.appearance) ve Tarih ve Saat
 * (profile.timeDate) alt grupları tek sekmede toplanır. İkisi de ekranın
 * kullanıcıya bakan yüzünü ayarlar ve toplamda 6 alan tutar; ayrı sekme
 * olmaları filtre şeridini gereksiz uzatıyordu. Başlıklar makinedeki menü
 * adlarıyla aynıdır (ScreenSetting = "Görüntü Ayarları").
 *
 * DİKKAT: yalnızca SUNUM birleşti. Yazma grupları ayrı kalır
 * (`profile.appearance` / `profile.timeDate`) — sunucu süzgeci ve rol şablonu
 * anahtar yolları bu iki grubu ayrı tanır.
 */
export default function AppearanceSection({
  appearance,
  timeDate,
  onChange,
  originalAppearance,
  originalTimeDate,
}) {
  const appearanceKeys = appearance ? Object.keys(appearance) : [];
  const timeDateKeys = timeDate ? Object.keys(timeDate) : [];
  if (appearanceKeys.length === 0 && timeDateKeys.length === 0) return null;

  // Tek alt grup kaldıysa (rol şablonu diğerini kapatmışsa) başlık gürültü olur.
  const showHeaders = appearanceKeys.length > 0 && timeDateKeys.length > 0;

  return (
    <SettingsSectionShell
      icon={FaPalette}
      title="Görüntü ve Saat"
      subtitle="Ekran tercihleri, otomatik saat ve format"
      count={appearanceKeys.length + timeDateKeys.length}
      color={COLOR}
    >
      {appearanceKeys.length > 0 && (
        <div>
          {showHeaders && (
            <SettingsSubgroupHeader
              icon={FaPalette}
              title="Görüntü Ayarları"
              count={appearanceKeys.length}
              color={COLOR}
            />
          )}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 mb-4 last:mb-0">
            {appearanceKeys.map((k) => {
              const setting = appearance[k];
              const orig = originalAppearance?.[k]?.value;
              const isChanged =
                orig !== undefined && !valuesEqual(setting.value, orig);
              return (
                <SettingsFieldCard
                  key={k}
                  setting={setting}
                  onChange={(value) =>
                    onChange({ group: "profile.appearance", key: k, value })
                  }
                  isChanged={isChanged}
                  originalValue={orig}
                  color={COLOR}
                />
              );
            })}
          </div>
        </div>
      )}

      <TimeDateSection
        data={timeDate}
        onChange={onChange}
        originalData={originalTimeDate}
        showHeader={showHeaders}
      />
    </SettingsSectionShell>
  );
}
